// What App Factory's run lists share between our staff page (AppFactory.tsx)
// and an outside client's (ClientFactory.tsx): step colours, words and times.
import type { FactoryStepStatus } from '@/api/factory';

export const STEP_DOT: Record<FactoryStepStatus, string> = {
  done: 'bg-success border-success',
  running: 'bg-primary/60 border-primary animate-pulse',
  needs_you: 'bg-warning border-warning',
  failed: 'bg-danger border-danger',
  waiting: 'bg-transparent border-border-strong',
  skipped: 'bg-transparent border-content-subtle border-dashed',
};
export const STEP_TEXT: Record<FactoryStepStatus, string> = {
  done: 'text-success', running: 'text-primary', needs_you: 'text-warning', failed: 'text-danger',
  waiting: 'text-content-subtle', skipped: 'text-content-subtle',
};
export const STEP_WORD: Record<FactoryStepStatus, string> = {
  done: 'Done', running: 'Running', needs_you: 'Needs you', failed: 'Failed', waiting: 'Waiting', skipped: 'Skipped',
};

export function fmtUnix(s: number | null): string {
  if (!s) return '—';
  return new Date(s * 1000).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function fmtDuration(from: number, to: number | null): string {
  const s = Math.max(0, (to ?? Math.floor(Date.now() / 1000)) - from);
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))} min`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ${Math.round((s % 3600) / 60)} min`;
  return `${Math.floor(s / 86400)} d`;
}
